import React from "react";

const Counter = ({count, setCount, max, isDisabled}) => {

    const increase = () => {
        setCount(prevState => prevState < max ? prevState + 1 : prevState)
    }

    const decrease = () => {
        setCount(prevState => prevState > 1 ? prevState - 1 : prevState)
    }

    return (
        <div className="bazaar_current-item_transfer-modal_counter">
            <button disabled={isDisabled} onClick={decrease}>-</button>
            <span>{count}</span>
            <button disabled={isDisabled} onClick={increase}>+</button>
        </div>
    )
}

export default Counter